/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetInspectionMetricDto,
    GetInspectionMetricDtoFromJSON,
    GetInspectionMetricDtoFromJSONTyped,
    GetInspectionMetricDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetInspectionExtendedDto
 */
export interface GetInspectionExtendedDto {
    /**
     * 
     * @type {string}
     * @memberof GetInspectionExtendedDto
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetInspectionExtendedDto
     */
    cpr: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetInspectionExtendedDto
     */
    witnesses: string;
    /**
     * 
     * @type {string}
     * @memberof GetInspectionExtendedDto
     */
    findingsBeginning: string;
    /**
     * 
     * @type {string}
     * @memberof GetInspectionExtendedDto
     */
    findingsEnd: string;
    /**
     * 
     * @type {Date}
     * @memberof GetInspectionExtendedDto
     */
    endDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof GetInspectionExtendedDto
     */
    notes: string;
    /**
     * 
     * @type {string}
     * @memberof GetInspectionExtendedDto
     */
    protocols: string;
    /**
     * 
     * @type {string}
     * @memberof GetInspectionExtendedDto
     */
    attachments: string;
    /**
     * 
     * @type {string}
     * @memberof GetInspectionExtendedDto
     */
    repairMethod: string;
    /**
     * 
     * @type {string}
     * @memberof GetInspectionExtendedDto
     */
    placeOfSignature: string;
    /**
     * 
     * @type {Date}
     * @memberof GetInspectionExtendedDto
     */
    signatureDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof GetInspectionExtendedDto
     */
    refusalReason: string;
    /**
     * 
     * @type {string}
     * @memberof GetInspectionExtendedDto
     */
    cautionText: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetInspectionExtendedDto
     */
    cautionIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetInspectionExtendedDto
     */
    cautionValues: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof GetInspectionExtendedDto
     */
    approved: boolean;
    /**
     * 
     * @type {GetInspectionMetricDto}
     * @memberof GetInspectionExtendedDto
     */
    metric: GetInspectionMetricDto;
    /**
     * 
     * @type {boolean}
     * @memberof GetInspectionExtendedDto
     */
    hasNotApprovedProductType: boolean;
}

export function GetInspectionExtendedDtoFromJSON(json: any): GetInspectionExtendedDto {
    return GetInspectionExtendedDtoFromJSONTyped(json, false);
}

export function GetInspectionExtendedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInspectionExtendedDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'cpr': json['cpr'],
        'witnesses': json['witnesses'],
        'findingsBeginning': json['findingsBeginning'],
        'findingsEnd': json['findingsEnd'],
        'endDate': !exists(json, 'endDate') ? undefined : (new Date(json['endDate'])),
        'notes': json['notes'],
        'protocols': json['protocols'],
        'attachments': json['attachments'],
        'repairMethod': json['repairMethod'],
        'placeOfSignature': json['placeOfSignature'],
        'signatureDate': !exists(json, 'signatureDate') ? undefined : (new Date(json['signatureDate'])),
        'refusalReason': json['refusalReason'],
        'cautionText': json['cautionText'],
        'cautionIds': json['cautionIds'],
        'cautionValues': json['cautionValues'],
        'approved': json['approved'],
        'metric': GetInspectionMetricDtoFromJSON(json['metric']),
        'hasNotApprovedProductType': json['hasNotApprovedProductType'],
    };
}

export function GetInspectionExtendedDtoToJSON(value?: GetInspectionExtendedDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'cpr': value.cpr,
        'witnesses': value.witnesses,
        'findingsBeginning': value.findingsBeginning,
        'findingsEnd': value.findingsEnd,
        'endDate': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
        'notes': value.notes,
        'protocols': value.protocols,
        'attachments': value.attachments,
        'repairMethod': value.repairMethod,
        'placeOfSignature': value.placeOfSignature,
        'signatureDate': value.signatureDate === undefined ? undefined : (value.signatureDate.toISOString()),
        'refusalReason': value.refusalReason,
        'cautionText': value.cautionText,
        'cautionIds': value.cautionIds,
        'cautionValues': value.cautionValues,
        'approved': value.approved,
        'metric': GetInspectionMetricDtoToJSON(value.metric),
        'hasNotApprovedProductType': value.hasNotApprovedProductType,
    };
}


